import * as ItemTypes from '@disco/constants/ItemTypes'
import { getSelectionIndexes } from '@disco/state-management/selectors/selection'
import cuid from 'cuid'

import React, { useState } from 'react'
import { useSelector } from 'hooks/use-redux'
import type { ExplorerPane } from 'types/explorer'
import { SelectionProvider } from 'contexts/selection'
import PaneItems from './PaneItems'
import { Group } from 'types/group'
type UploadFilesToMainTrack = any

export type Props = {
  appendTracksToPlaylist: (...args: Array<any>) => any
  addNestedTracksToMain?: (...args: Array<any>) => any
  uploadFilesToMainTrack?: UploadFilesToMainTrack
  componentHeight?: 'Default' | 'Compact'
  groups: Group[]
  isLoading: boolean
  isSimilarity?: boolean
  items: Record<string, any>[]
  library?: Group
  loadNext: () => void
  nextPageUrl?: string
  pane: ExplorerPane
  sections?: Record<string, any>[]
  selectedItems: Record<string, any>[]
  trackVersionsButton?: React.ReactNode
  disableSelection?: boolean
  disabledDrop?: boolean
  withSortable?: {
    accept: (typeof ItemTypes)[keyof typeof ItemTypes][]
    id: string
  }
  disableItemClick?: boolean
  disablePaneOpen?: boolean
  itemPrefix?: string
  isNested?: boolean
  selectionId?: string
}

export type PaneItemsContainerProps = Props & {
  manualScroll?: boolean
  searchType?: string | null | undefined
  subPaneOpen?: boolean
}

// The container supplies paneSelection itself, so only the inner PaneItems requires it.
export type PaneItemsProps = PaneItemsContainerProps & {
  paneSelection: number[]
}

const PaneItemsContainer = (
  props: PaneItemsContainerProps,
): React.ReactNode => {
  const [selectionId] = useState(cuid())
  const paneSelection = useSelector(state =>
    getSelectionIndexes(state, selectionId),
  )
  return (
    <SelectionProvider
      value={{
        id: selectionId,
        data: props.items.filter(Boolean),
        paneIndex: props.pane.index,
        isNested: props.isNested,
      }}
    >
      <PaneItems {...props} paneSelection={paneSelection} />
    </SelectionProvider>
  )
}

export default PaneItemsContainer
